// Angular
import {  Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
// Auth
import { AuthService } from '../../../../core/auth';

@Component({
	selector: 'kt-logout',
	templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
	// Public params
	

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * */
	constructor(
		private router: Router,
		private auth: AuthService,
	) {
		
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.auth.logout();
	}



}
